// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"_3s8mQp","grid":"_1PKz8P","centered-section-spacing":"_1d0kef","grid-odd":"BXeOaX","box":"_3ORGKi","header":"_1RSWtI","container":"_1lkfVs"};